export const GSTService = {
    postOTPGeneration,
    postFetchMutipleGST,
    postGSTData
}

const { REACT_APP_CREDIT_SERVICE_API_BASE_URL } = process.env;

function postOTPGeneration(OTP) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(OTP)
    };
    return fetch(`${REACT_APP_CREDIT_SERVICE_API_BASE_URL}/api/v1/gst/otp_generate`, requestOptions).then(handleResponse);
}

function postFetchMutipleGST(GST) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(GST)
    };

    return fetch(`${REACT_APP_CREDIT_SERVICE_API_BASE_URL}/api/v1/gst/get_gstin`, requestOptions).then(handleResponse);
}

function postGSTData(GST) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(GST)
    };

    return fetch(`${REACT_APP_CREDIT_SERVICE_API_BASE_URL}/api/v1/gst/gst_data`, requestOptions).then(handleResponse);
}

function handleResponse(response) {

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (response.status === 422) {
            const error = (data && data) || response.statusText;
            return Promise.reject({ error, status: response.status });
        }
        if (!response.ok) {
            const error = (data && data) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}